import { Text } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";

import type { LabelValue } from "./types";

type SummaryItemRowProps = LabelValue & { isCombined: boolean };

export const SummaryItemRow = ({
  label,
  value,
  isCombined,
}: SummaryItemRowProps) => (
  <div className="mobius-payment-items-section__summary-row">
    <Text
      variant="small"
      spacing="tight"
      className={classNames("mobius-payment-items-section__summary-text", {
        "mobius-payment-items-section__summary-text--combined": isCombined,
      })}
    >
      {label}
    </Text>
    <Text
      variant="small"
      spacing="tight"
      className={classNames(
        "mobius-payment-items-section__summary-text",
        "mobius-payment-items-section__summary-text--right",
        { "mobius-payment-items-section__summary-text--combined": isCombined },
      )}
    >
      {value}
    </Text>
  </div>
);

SummaryItemRow.displayName = "SummaryItemRow";
